<template>
<div class="pt-6 px-4 sm:px-6">

  <div>
    <h2 class="text-lg leading-6 font-medium text-gray-900">Enquiries</h2>
    <p class="mt-1 text-sm text-gray-500">
      Enquires you have received from prospective students visiting your profile.
    </p>
  </div>


  <div v-if="!$store.getters.hasViewedTestEnquiryEmail">
    <div v-if="!testEnquirySent" class="-mx-4 mt-4 bg-yellow-50 p-4 sm:mx-0 sm:rounded-md">
      <div class="flex">
        <div class="hidden flex-shrink-0 sm:block">
          <ExclamationIcon class="w-6 h-6 text-yellow-400" />
        </div>
        <div class="sm:ml-3">
          <div class="flex items-center space-x-2 sm:space-x-0">
            <ExclamationIcon class="flex-shrink-0 self-start w-6 h-6 text-yellow-400 sm:hidden" />
            <h3 class="text-sm font-medium text-yellow-800">Send a test enquiry</h3>
          </div>
          <div class="mt-2 prose prose-sm">
            <p>
              Ensure you don’t miss out on potential leads by sending a test enquiry notification to yourself.
              You will receive enquiries at <strong>{{ $store.getters.user.Email }}</strong>. <router-link :to="{ name: 'EditTutor-Profile' }">Need to change this?</router-link>
            </p>
            <TailwindButton
              :loading="testEnquirySending"
              :disabled="testEnquirySending"
              @click="sendTestEnquiry"
              class="px-6"
            >
              Send Test Enquiry
            </TailwindButton>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="-mx-4 mt-4 bg-yellow-50 p-4 sm:mx-0 sm:rounded-md">
      <div class="flex">
        <div class="hidden flex-shrink-0 sm:block">
          <ExclamationIcon class="w-6 h-6 text-yellow-400" />
        </div>
        <div class="sm:ml-3">
          <div class="flex items-center space-x-2 sm:space-x-0">
            <ExclamationIcon class="flex-shrink-0 self-start w-6 h-6 text-yellow-400 sm:hidden" />
            <h3 class="text-sm font-medium text-yellow-800">Enquiry Sent</h3>
          </div>
          <div class="mt-2 prose prose-sm">
            <p>
              A test enquiry has been sent to <strong>{{ $store.getters.user.Email }}</strong>. Please open the email to complete this task.
            </p>
            <p>
              If the email does not arrive in your inbox, please check your spam/junk folder.
            </p>
            <p>
              Remember to add <strong>notifications@thetutorindex.com</strong> to your list of safe-senders to ensure you always receive enquiries.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <ul v-if="enquiries.length > 0" class="-mx-4 mt-8 divide-y divide-gray-200 sm:-mx-6">

    <tti-enquiry 
      v-for="enquiry in enquiries" 
      :enquiry="enquiry" 
      :key="enquiry.Id"
      @delete="onEnquiryDelete">
    </tti-enquiry>

  </ul>
  <div v-else class="px-6 py-10 text-center text-gray-600">

    No enquiries found.

  </div>

</div>    
</template>
<script>
import { ExclamationIcon } from '@vue-hero-icons/solid'
import TailwindButton from './TailwindButton.vue'

import EnquiryService from '@/services/EnquiryServices'
const enquiryService = new EnquiryService()

export default {
  components: {
    "tti-enquiry": () => import("./EditTutor-Enquiry"),
    TailwindButton,
    ExclamationIcon,
  },
  data() {
    return {
      enquiries: [],
      testEnquirySending: false,
      testEnquirySent: false,
      testEnquiryChecker: null,
    }
  },
  methods: {
    loadEnquiries() {
      return enquiryService.get()
        .then(response => {
          this.enquiries = response.data
        })
    },
    onEnquiryDelete(id) {
      var index = this.enquiries.findIndex(x => x.Id === id)
      this.$delete(this.enquiries, index)
    },
    async sendTestEnquiry() {
      this.testEnquirySending = true
      await enquiryService.sendTestEnquiry()
      this.testEnquirySending = false
      this.testEnquirySent = true

      this.testEnquiryChecker = setInterval(() => {
        this.$store.dispatch('refreshUser')
        if (this.$store.getters.hasViewedTestEnquiryEmail) {
          clearInterval(this.testEnquiryChecker)
        }
      }, 5000)
    }
  },
  mounted() {
    this.loadEnquiries().then(() => {
      this.$store.dispatch('getNumberOfUnseenEnquiries')
    })
  },
  unmounted() {
    clearInterval(this.testEnquiryChecker)
  }
}
</script>